var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSpeaker = function SvgIcSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_speaker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.852 5.096a1.266 1.266 0 0 0-1.377.274l-5.422 5.944h-3.79c-.695 0-1.263.57-1.263 1.263v7.58c0 .694.568 1.262 1.263 1.262h3.79l5.422 5.947a1.263 1.263 0 0 0 2.157-.894V6.262a1.261 1.261 0 0 0-.78-1.166ZM19.156 7.525v2.527a6.324 6.324 0 0 1 6.316 6.316 6.323 6.323 0 0 1-6.316 6.315v2.527c4.876 0 8.842-3.966 8.842-8.843 0-4.874-3.966-8.842-8.842-8.842Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.946 16.368c0-2.088-1.7-3.79-3.79-3.79v2.526c.696 0 1.263.568 1.263 1.264 0 .696-.567 1.263-1.263 1.263v2.526c2.09 0 3.79-1.699 3.79-3.79Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_speaker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgIcSpeaker;